module.exports = __webpack_public_path__ + "json/fence-0.json?d9b45b6980ec22755634598b10d9d73e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/fence/fence-0.json
// module id = 1734
// module chunks = 3